import { render } from "./AlertsNotifications.vue?vue&type=template&id=b7a92b26&scoped=true"
import script from "./AlertsNotifications.vue?vue&type=script&lang=js"
export * from "./AlertsNotifications.vue?vue&type=script&lang=js"

import "./AlertsNotifications.vue?vue&type=style&index=0&id=b7a92b26&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a92b26"]])

export default __exports__